
document.querySelectorAll('a[href^="#"]').forEach((el) => {
    el.addEventListener('click', (e) => {
        console.log(e.target);
        e.preventDefault();

        const target = document.querySelector(e.target.getAttribute('href'));
        if (target != '#login' || target != '#recover') {
            if (target) {
                const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({
                    top: targetPosition - 100, // Adds 100px offset
                    behavior: 'smooth'
                });
            }
        } else {
            // If the target is #login or #recover, just scroll to the top
            console.log('coucou');

            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    });
});


document.addEventListener('DOMContentLoaded', () => {
    // Select all elements with data-product-review-note attribute
    const ratingElements = document.querySelectorAll('[data-product-review-note]');

    ratingElements.forEach(element => {
        // Get the rating value (0 to 5)
        const rating = parseFloat(element.getAttribute('data-product-review-note'));

        // Find the SVG within this element
        const svg = element.querySelector('svg');
        if (!svg) return;

        // Get all star paths within the SVG
        const stars = svg.querySelectorAll('path');

        // Loop through each star and set fill color based on rating
        stars.forEach((star, index) => {
            if (index < Math.floor(rating)) {
                // Full star: keep original color (#E64601)
                star.setAttribute('fill', '#E64601');
            } else if (index === Math.floor(rating) && rating % 1 !== 0) {
                // Partial star: create a gradient for fractional rating
                const gradientId = `partial-star-${index}-${Date.now()}`;
                const gradient = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
                gradient.setAttribute('id', gradientId);
                gradient.innerHTML = `
          <stop offset="${rating % 1 * 100}%" stop-color="#E64601"/>
          <stop offset="${rating % 1 * 100}%" stop-color="#D3D3D3"/>
        `;
                svg.querySelector('defs') || svg.insertAdjacentHTML('afterbegin', '<defs></defs>');
                svg.querySelector('defs').appendChild(gradient);
                star.setAttribute('fill', `url(#${gradientId})`);
            } else {
                // Empty star: gray color
                star.setAttribute('fill', '#D3D3D3');
            }
        });
    });
});

class ProductCard extends HTMLElement {
    constructor() {
        super();
        this.mq = window.matchMedia('(max-width: 649px)'); // < 650px
    }

    connectedCallback() {
        // Contexte
        this.section = this.closest('[data-section-type="w-product-slider"]');
        this.isInSlider = !!this.section;
        this.isSwiperCard = this.classList.contains('swiper-card');

        // Boutons (haut et bas)
        this.buttons = this.querySelectorAll('[add-to-cart]');

        // Overlay global (créé une seule fois)
        this.overlay = document.querySelector('.product-card__overlay');
        if (!this.overlay) {
            this.overlay = document.createElement('div');
            this.overlay.className = 'product-card__overlay';
            this.overlay.setAttribute('aria-hidden', 'true');
            document.body.appendChild(this.overlay);
        }
        // Attacher UNE FOIS le listener overlay (ferme tout + enlève --visible)
        if (!this.overlay.dataset.pcBound) {
            this.overlay.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation?.();
                this._closeAllPanels(); // _closePanel enlève immédiatement --visible & expanded
            }, true);
            this.overlay.dataset.pcBound = '1';
        }

        // Écouteur global pour la croix de fermeture (capture en amont)
        if (!document.documentElement.dataset.pcCloseBound) {
            document.addEventListener('click', (e) => {
                const closeBtn = e.target.closest('.product-card__add-top__close');
                if (!closeBtn) return;
                e.preventDefault();
                e.stopPropagation();
                const panel = closeBtn.closest('.product-card__add');
                if (panel) this._closePanel(panel);
            }, true);
            document.documentElement.dataset.pcCloseBound = '1';
        }

        // Un SEUL handler par bouton : il s’adapte au mode (swiper/mobile ou défaut)
        this.buttons.forEach((btn) => {
            if (btn._pcBound) return;
            btn._pcBound = '1';
            btn.addEventListener('click', (e) => this._onButtonClick(btn, e), true);
        });

        // Binder variantes du panel local si présent (utile pour mode défaut)
        const localPanel = this.querySelector('.product-card__add');
        if (localPanel) this._bindVariantClicks(localPanel, this.querySelector('[add-to-cart]'));

        // Sur changement de breakpoint : on ferme tout proprement
        if (!document.documentElement.dataset.pcMQBound) {
            this.mq.addEventListener('change', () => this._closeAllPanels());
            document.documentElement.dataset.pcMQBound = '1';
        }
    }

    // ----------------- Gestion click bouton -----------------
    _onButtonClick(button, e) {
        const useExternal = this.isSwiperCard && this.isInSlider && this._isMobile();
        if (useExternal) {
            // Mode SWIPER + mobile : panel EXTERNE par product id
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation?.();

            const targetId = button.getAttribute('data-toggle-target') || '';
            const match = targetId.match(/product-card-add-(\d+)/);
            if (!match) return;

            const productId = match[1];
            const panel = document.getElementById(`product-card-add-${productId}`);
            if (!panel) return;

            const topEl =
                panel.querySelector('.product-card__add-top--visible') ||
                panel.querySelector('.product-card__add-top');
            const priceEl = panel.querySelector('.product-card__add-price');

            // Fermer tous les autres panels
            this._closeAllPanels(panel.id);

            // Si déjà ouvert → ajout direct
            if (topEl && topEl.classList.contains('product-card__add-top--visible')) {
                const activeVariantId = button.getAttribute('data-current-variant-id');
                if (activeVariantId) this.addToCart(activeVariantId, 1, button);
                return;
            }

            // Ouvrir (anim + overlay)
            this._openPanel(panel, topEl, priceEl);

            // Binder variantes (une seule fois) sur le panel EXTERNE
            this._bindVariantClicks(panel, button);
            button.classList.add('expanded');
            return;
        }

        // Mode par défaut (panel local, comportement d’origine)
        this._handleDefaultClick(button);
    }

    // ----------------- Mode par défaut (local) -----------------
    _handleDefaultClick(button) {
        const targetId = button.getAttribute('data-toggle-target');
        const addContainer =
            this.querySelector('.product-card__add') || (targetId ? document.getElementById(targetId) : null);
        if (!addContainer) return;

        // Fermer tous les autres panels (garder celui-ci)
        this._closeAllPanels(addContainer.id || '');

        const priceElement = addContainer.querySelector('.product-card__add-price');
        const topElement =
            addContainer.querySelector('.product-card__add-top--visible') ||
            addContainer.querySelector('.product-card__add-top');
        let innerBtn = addContainer.querySelector('[add-to-cart]') || button;

        // Si déjà visible => ajout direct
        if (topElement && topElement.classList.contains('product-card__add-top--visible')) {
            const activeVariantId = innerBtn.getAttribute('data-current-variant-id');
            if (activeVariantId) this.addToCart(activeVariantId, 1, innerBtn);
            return;
        }

        // Ouverture "classique" (sans overlay global)
        priceElement && priceElement.classList.add('product-card__add-price--visible');
        innerBtn.classList.add('expanded');

        setTimeout(() => {
            if (!topElement) return;
            topElement.classList.add('product-card__add-top--visible');
            topElement.classList.remove('product-card__add-top--hidden');
        }, 300);
    }

    // ----------------- Variantes (local ou externe) -----------------
    _bindVariantClicks(panel, triggerBtn) {
        if (!panel || panel._pcVariantsBound) return;
        panel._pcVariantsBound = true;

        panel.querySelectorAll('.product-card__add-top__item').forEach((item) => {
            if (item._pcBound) return;
            item._pcBound = true;

            item.addEventListener('click', (ev) => {
                ev.stopPropagation();
                ev.stopImmediatePropagation?.();

                const variantId = item.getAttribute('data-variant-id');

                // Actif visuel
                panel.querySelectorAll('.product-card__add-top__item').forEach((el) => el.classList.remove('active'));
                item.classList.add('active');

                // MAJ prix
                const priceElement = panel.querySelector('.product-card__add-price');
                const price = item.getAttribute('data-price') || '';
                const comparedAtPrice = item.getAttribute('data-compared-at-price') || '';
                if (priceElement) {
                    priceElement.innerHTML = `<span>|</span> <span class="product-card__compare-price">${comparedAtPrice}</span> ${price}`;
                }

                // MAJ variant courant sur le bouton trigger
                if (triggerBtn) {
                    const currentVariantId = triggerBtn.getAttribute('data-current-variant-id');
                    if (variantId && variantId !== currentVariantId) {
                        triggerBtn.setAttribute('data-current-variant-id', variantId);
                    }
                }
            });
        });
    }

    // ----------------- Ouverture / Fermeture panels (anim + overlay) -----------------
    _openPanel(panel, topEl, priceEl) {
        if (!panel) return;

        // Overlay ON
        document.body.classList.add('is-open');
        this.overlay.setAttribute('aria-hidden', 'false');

        // Animations
        panel.classList.add('product-card__add--opening');
        requestAnimationFrame(() => {
            panel.classList.add('product-card__add--visible');
            priceEl && priceEl.classList.add('product-card__add-price--visible');
            topEl?.classList.remove('product-card__add-top--hidden');
            topEl?.classList.add('product-card__add-top--visible');
            // Fin d’ouverture
            setTimeout(() => panel.classList.remove('product-card__add--opening'), 300);
        });
    }

    _closePanel(panel) {
        if (!panel) return;

        const priceEl = panel.querySelector('.product-card__add-price');
        const topEl =
            panel.querySelector('.product-card__add-top--visible') ||
            panel.querySelector('.product-card__add-top');

        // Retirer immédiatement l'état "visible"
        panel.classList.remove('product-card__add--visible');

        // Retirer tous les "expanded" liés à CE panel
        panel.querySelectorAll('[add-to-cart].expanded').forEach((b) => b.classList.remove('expanded'));
        if (panel.id) {
            document
                .querySelectorAll(`[add-to-cart][data-toggle-target="${panel.id}"].expanded`)
                .forEach((b) => b.classList.remove('expanded'));
        }

        // Phase de fermeture (optionnelle) + fermer le "top"
        panel.classList.add('product-card__add--closing');
        if (topEl) {
            topEl.classList.add('product-card__add-top--hidden');
            topEl.classList.remove('product-card__add-top--visible');
        }

        // Fin de fermeture après transition (300ms)
        setTimeout(() => {
            priceEl?.classList.remove('product-card__add-price--visible');
            panel.classList.remove('product-card__add--closing', 'product-card__add--opening');

            // Couper l'overlay si aucun panel n'est ouvert
            if (!document.querySelector('.product-card__add.product-card__add--visible') &&
                !document.querySelector('.product-card__add-top--visible')) {
                document.body.classList.remove('is-open');
                this.overlay && this.overlay.setAttribute('aria-hidden', 'true');
            }
        }, 300);
    }

    _closeAllPanels(keepId = '') {
        // Ferme tout, sauf éventuellement celui dont l'id === keepId
        document.querySelectorAll('.product-card__add').forEach((panel) => {
            if ((panel.id || '') !== keepId) this._closePanel(panel);
        });
    }

    // ----------------- Utils -----------------
    _isMobile() {
        return this.mq.matches; // < 650px
    }

    // ----------------- Add to cart (inchangé) -----------------
    addToCart(variantId, quantity = 1, button) {
        if (!variantId || !button) return;

        const originalText = button.textContent;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'AJOUT...';

        const randomId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity, properties: { _random: randomId } }),
        })
            .then((res) => res.json())
            .then(() => {
                button.textContent = 'AJOUTÉ !';
                document.dispatchEvent(new Event('product:added'));
            })
            .catch((err) => console.error('❌ Erreur ajout panier :', err))
            .finally(() => {
                button.disabled = false;
                button.removeAttribute('aria-busy');
                button.textContent = originalText;
            });
    }
}

customElements.define('product-card', ProductCard);

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
        mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

        const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        modalContent.prepend(newMediaModal);
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        inputWrappers.forEach((option, index) => {
            if (index === 0) return;
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
            const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
            const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected).map(variantOption => variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue)
        });
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach(input => {
            if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
                input.innerText = input.getAttribute('value');
            } else {
                input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
            }
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;

        const productForm = section.querySelector('product-form');
        // if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
        const requestedVariantId = this.currentVariant.id;
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

        //  change the variant id in the add-to-cart button
        const addToCartButton = document.querySelector(`.product-form__add-to-cart [data-action="add-to-cart"]`);
        if (addToCartButton) {
            addToCartButton.setAttribute('variant-id', requestedVariantId);
            addToCartButton.setAttribute('data-original-price', this.currentVariant.price);
        }

        // Update sticky button data-original-price
        const stickyButton = document.querySelector('.product-form__sticky-submit-button button');
        if (stickyButton) {
            stickyButton.setAttribute('data-variant-id', requestedVariantId);
            stickyButton.setAttribute('data-original-price', this.currentVariant.price);
        }

        // Update button price with discount if applicable (if on product page with quantity steps)
        if (document.querySelector('.quantity_step--container')) {
            const productForm = document.querySelector('product-form');
            if (productForm && typeof productForm.updateButtonPrice === 'function') {
                productForm.updateButtonPrice();
            }
        }

        fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                // prevent unnecessary ui changes from abandoned selections
                if (this.currentVariant.id !== requestedVariantId) return;

                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.getElementById(`price-${this.dataset.section}`);
                const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
                const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

                if (source && destination) destination.innerHTML = source.innerHTML;
                if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
                if (skuSource && skuDestination) {
                    skuDestination.innerHTML = skuSource.innerHTML;
                    skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
                }

                const price = document.getElementById(`price-${this.dataset.section}`);

                if (price) price.classList.remove('visibility-hidden');

                if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

                const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
                this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

                // publish(PUB_SUB_EVENTS.variantChange, {
                //     data: {
                //         sectionId,
                //         html,
                //         variant: this.currentVariant
                //     }
                // });
            });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);

        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('visibility-hidden');
        if (inventory) inventory.classList.add('visibility-hidden');
        if (sku) sku.classList.add('visibility-hidden');
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach(input => {
            if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
                input.classList.remove('disabled');
            } else {
                input.classList.add('disabled');
            }
        });
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
}

customElements.define('variant-radios', VariantRadios);


class FaqCollapse extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.querySelectorAll(".faq-item-title").forEach((button) => {
            button.addEventListener("click", this.toggleFaqItem.bind(this));
        });


        if (document.querySelector('.faq-collapse__nav')) {
            const faqCollapse = document.querySelector('.faq-collapse__nav');
            const faqItems = document.querySelectorAll('.faq-collapse__item');

            faqCollapse.addEventListener('click', function (event) {
                if (event.target.tagName === 'BUTTON') {
                    const handle = event.target.getAttribute('data-button-handle');
                    // Remove active class from all buttons
                    faqCollapse.querySelectorAll('button').forEach((btn) => {
                        btn.classList.remove('active');
                    });
                    // Add active class to the clicked button
                    event.target.classList.add('active');
                    faqItems.forEach((item) => {
                        if (item.getAttribute('data-handle') === handle) {
                            item.classList.remove('hidden');
                        } else {
                            item.classList.add('hidden');
                        }
                    });
                }
            });
        }

    }

    toggleFaqItem(e) {
        e.currentTarget
            .querySelector(".faq-close")
            .classList.toggle("faq-display-none");

        e.currentTarget.parentNode.classList.toggle("faq-item-active");

        const item = e.currentTarget.parentNode.querySelector(".faq-item-text");
        console.log(item);

        item.slideToggle("250");
    }
}

customElements.define('faq-collapse', FaqCollapse);